import { render, staticRenderFns } from "./termlyPost.vue?vue&type=template&id=0463c75a&scoped=true"
import script from "./termlyPost.vue?vue&type=script&lang=js"
export * from "./termlyPost.vue?vue&type=script&lang=js"
import style0 from "./termlyPost.vue?vue&type=style&index=0&id=0463c75a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0463c75a",
  null
  
)

export default component.exports